module.exports = __webpack_public_path__ + "static/media/interaction_lab.95fde221.png";